
import { defineComponent, computed, ref, watchEffect } from 'vue';
import { debounce } from '@utiles/index';
export default defineComponent({
  name: 'LikeBtn',
  props: {
    linkTotalNum: {
      type: Number,
      required: true,
    },
    isLike: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShowAnimate: {
      type: Boolean,
      required: false,
      default: false,
    },
    likeType: {
      type: String,
      required: false,
    },
  },
  emits: ['cancelLike', 'like'],
  setup(props: any, { emit }) {
    const totalNum = computed(() => {
      if (+props.linkTotalNum <= 999) {
        return props.linkTotalNum;
      }
      return '999+';
    });
    const likeGtmClass = computed(() => {
      if (props.isLike) {
        return `gtm-cancellike-${props.likeType}`;
      }
      return `gtm-like-${props.likeType}`;
    });
    const handleLike = debounce(() => {
      props.isLike ? emit('cancelLike') : emit('like');
    }, 500);

    const isShowPlusText = ref(false);

    watchEffect(() => {
      if (props.isShowAnimate) {
        isShowPlusText.value = true;
        setTimeout(() => {
          isShowPlusText.value = false;
        }, 1000);
      }
    });

    return {
      totalNum,
      handleLike,
      isShowPlusText,
      likeGtmClass,
    };
  },
});
